'use client';

import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {Doughnut} from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

type DoughnutChartProps = {
  labels?: string[];
  dataValues: number[];
  centerText?: string;
  bgColors?: string[];
};

export const DoughnutChart: React.FC<DoughnutChartProps> = ({
  dataValues,
  centerText,
  bgColors,
}) => {
  const data = {
    labels: ['Productivity', 'Efficiency'],
    datasets: [
      {
        data: dataValues,
        backgroundColor: bgColors,
        barThickness: 7,
        borderJointStyle: 'round',
        borderRadius: 999,
        width: 10,
      },
    ],
  };

  const centerTextPlugin = {
    id: 'centerTextPlugin',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    beforeDraw: (chart: any) => {
      const {width, height, ctx} = chart;
      ctx.restore();
      const fontSize = (height / 50).toFixed(2);
      ctx.font = `${fontSize}em inter`;
      ctx.textBaseline = 'middle';

      const text = centerText;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  };

  const options = {
    resposive: false,
    cutout: '75%',
    aspectRation: 2,
    animations: {
      duration: 1000,
      easing: 'linear',
      from: 1,
      to: 0,
    },
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
        align: 'center',
        usePointStyle: true,
        pointStyle: 'circle',
      },
    },
  };

  return (
    <Doughnut
      data={data}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      options={options as any}
      plugins={[centerTextPlugin]}
    />
  );
};
